import React from "react";
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { faker } from "@faker-js/faker";

ChartJS.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip
);

export const options = {
	responsive: true,
};

const labels = [
	"October",
	"November",
	"December",
	"January",
	"February",
	"March",
];

export const data = {
	labels,
	datasets: [
		{
			label: "Dataset 1",
			data: labels.map(() => faker.datatype.number({ min: -1000, max: 1000 })),
			borderColor: "rgb(255, 99, 132)",
			backgroundColor: "rgba(255, 99, 132, 0.5)",
		},
		{
			label: "Dataset 2",
			data: labels.map(() => faker.datatype.number({ min: -1000, max: 1000 })),
			borderColor: "rgb(53, 162, 235)",
			backgroundColor: "rgba(53, 162, 235, 0.5)",
		},
	],
};

function Charts() {
	return (
		<div className="md:w-1/3 border border-slate-100 bg-white dark:bg-darkbg dark:border-darkborder rounded-md shadow-sm px-5 py-2 flex-1">
			<h1 className="text-slate-500">Last 6 months (users)</h1>
			<div className="">
				<Line options={options} data={data} />
			</div>
		</div>
	);
}

export default Charts;
